import { Col, Form, Row } from "antd";
import { useEffect, useState } from "react";
import { FooterModal } from "../FooterModal";
import { DrawerModal } from "../DrawerModal";

interface FormModalProps {
  add: any;
  edit: any;
  title: string;
  onCancel: any;
  itemToEdit: any;
  visibility: boolean;
  rows: any[];
}

export const FormModal: React.FC<FormModalProps> = ({
  add,
  edit,
  rows,
  title,
  onCancel,
  visibility,
  itemToEdit,
  children,
}) => {
  const [form] = Form.useForm();
  const [, setUpdate] = useState(false);

  useEffect(() => {
    if (!visibility) {
      form.resetFields();
    } else if (itemToEdit) {
      setUpdate((update) => !update);
      form.setFieldsValue(itemToEdit);
    }
  }, [visibility, form, itemToEdit]);
  const onValuesChange = (changedValues: any, values: any) => {
    setUpdate((update) => !update);
    const data = {
      ...values,
      ...rows
        .flat()
        .map((input) =>
          typeof input === "function" ? input({ data: values }) : input
        )
        .filter((input) => input.onChange)
        .reduce(
          (acc, cur) => ({
            ...acc,
            [cur.name]: cur.onChange?.(changedValues, { ...values, ...acc }),
          }),
          {}
        ),
    };
    const dataEntries = Object.entries(data);
    form.setFields(dataEntries.map(([name, value]) => ({ name, value })));
    form.resetFields(
      dataEntries
        .filter(([, value]) => value === undefined || value === null)
        .map(([name]) => name)
    );
  };
  const onFinish = (data: any) => {
    if (itemToEdit) {
      edit(data);
    } else {
      add(data);
    }
  };

  return (
    <DrawerModal
      footer={null}
      title={title}
      onCancel={onCancel}
      visible={visibility}
    >
      <Form
        form={form}
        size="large"
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        {rows.map((row, index) => (
          <Row key={index} gutter={[16, 16]}>
            {row
              .map((input: any) =>
                typeof input === "function"
                  ? input({ data: form.getFieldsValue() })
                  : input
              )
              .filter(
                (input: any) =>
                  !(
                    typeof input.hide === "function" &&
                    input.hide({ data: form.getFieldsValue() })
                  )
              )
              .map((input: any, index: number, array: any[]) => (
                <Col
                  key={input.name}
                  span={input.span ? input.span : 24 / array.length}
                >
                  <Form.Item
                    name={input.name}
                    label={input.label}
                    rules={input.rules}
                    hidden={input.hidden}
                    valuePropName={input.valuePropName}
                  >
                    {input.input}
                  </Form.Item>
                </Col>
              ))}
          </Row>
        ))}
        {children}
        <FooterModal onCancel={onCancel} />
      </Form>
    </DrawerModal>
  );
};
